export const languags = [
    { label: '简体中文', value: 'zh_CN' },
    { label: '繁體中文', value: 'zh_HK' },
    { label: 'Español', value: 'es_ES' },
    { label: 'italiano', value: 'it_IT' },
    { label: 'français', value: 'fr_FR' },
    { label: 'Русский', value: 'ru_RU' },
    { label: 'Polski', value: 'pl_PL' },
    // { label: 'Deutsche', value: 'de_DE' },
    { label: '한국어', value: 'ko_KR' },
    { label: '日本語', value: 'ja_JP' },
    { label: 'English', value: 'en_US' },
    { label: 'हिंदी', value: 'en_IN' },
    { label: 'Indonesia', value: 'it_CH' },
    { label: 'Türkiye', value: 'tr_TR' },
    { label: 'ภาษาไทย', value: 'th_TH' },
]
export const languags1 = [
    { label: 'Español', value: 'es_ES' },
    { label: 'italiano', value: 'it_IT' },
    { label: 'français', value: 'fr_FR' },
    { label: 'Русский', value: 'ru_RU' },
    { label: 'Polski', value: 'pl_PL' },
    // { label: 'Deutsche', value: 'de_DE' },
    { label: '한국어', value: 'ko_KR' },
    { label: '日本語', value: 'ja_JP' },
    { label: 'English', value: 'en_US' },
    { label: 'हिंदी', value: 'en_IN' },
    { label: 'Indonesia', value: 'it_CH' },
    { label: 'Türkiye', value: 'tr_TR' },
    { label: 'ภาษาไทย', value: 'th_TH' },
]

export const tels = [
    { label: '+1', value: '美国', en: 'us' },
    { label: '+86', value: '中国', en: 'china' },
    { label: '+65', value: '新加坡', en: 'singapore' },
    { label: '+82', value: '韩国', en: 'korea' },
    { label: '+81', value: '日本', en: 'japan' },
    { label: '+66', value: '泰国', en: 'thailand' },
    { label: '+77', value: '俄罗斯', en: 'russia' },
    { label: '+44', value: '英国', en: 'uk' },
    { label: '+84', value: '越南', en: 'vietnam' },
    { label: '+91', value: '印度', en: 'india' },
    { label: '+39', value: '意大利', en: 'italy' },
    { label: '+852', value: '香港', en: 'hk' },
    { label: '+60', value: '马来西亚', en: 'malaysia' },
    { label: '+886', value: '台湾省', en: 'taiwan' },
    { label: '+90', value: '土耳其', en: 'turkey' },
    { label: '+49', value: '德国', en: 'germany' },
    { label: '+33', value: '法国', en: 'france' },
    { label: '+34', value: '西班牙', en: 'spain' },
]



// WEBPACK FOOTER //
// ./src/config/constant.js